import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { getHttp } from 'src/api'
import { PATH_API } from 'src/helpers'
import { useAppContext } from 'src/helpers/app'
import { API, IQuizSessionsResponse } from 'src/types'

export const useMoodboard = () => {
  const { sessionId } = useParams<{ sessionId: string }>()
  const location = useLocation<{ from: string }>()
  const { handleChangeAppData, setSessionID, setQuizSession } = useAppContext()

  useEffect(() => {
    const initPage = async () => {
      if (!sessionId) return

      if (location?.state?.from !== 'quiz-question') {
        handleChangeAppData({ countLoading: 1 })
      }
      try {
        const sessionResult: API<IQuizSessionsResponse> = await getHttp(PATH_API.getSessionId(sessionId))
        setQuizSession(sessionResult.data)
        setSessionID(sessionId)
      } catch (error) {
        console.error('initPage', error)
      }

      if (location?.state?.from === 'quiz-question') {
        handleChangeAppData({ countLoadingTestimonial: -1 })
      } else {
        handleChangeAppData({ countLoading: -1 })
      }
    }

    initPage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId])

  return {}
}
